import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styled from 'styled-components'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import MailSharpIcon from '@material-ui/icons/MailSharp'
import Divider from '@material-ui/core/Divider'
import Paper from '@material-ui/core/Paper'
import ChangePassword from './ChangePassword'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import { useQuery } from '@apollo/react-hooks'
import { userQueries } from '../../graphql/queries'
import CircularProgress from '@material-ui/core/CircularProgress'
import AccessibilityIcon from '@material-ui/icons/Accessibility';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: 'white',
    padding: '1px 16px 24px',
    marginTop: '30px',
    overflow: 'hidden'
  },
  icon: {
    fontSize: '32px'
  },
  title: {
    marginBottom: '10px'
  },
  passwordIcon: {
    fontSize: '20px'
  },
  passwordTitle: {
    fontSize: '14px',
    marginLeft: '-15px',
    textTransform: 'uppercase'
  },
  hr: {
    marginTop: '30px',
    marginBottom: '10px'
  },
  circularLoading: {
    margin: 'auto',
    alignSelf: 'center',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
}))
const IconAlign = styled.div`
  display: flex;
  margin-right: 20px;
`
const ProfileInfo = () => {
  const classes = useStyles()
  const { loading, data: dataUser, refetch } = useQuery(userQueries.GET_USER)
  if (loading) return <CircularProgress className={classes.circularLoading} />
  return (
    <Paper className={classes.root}>
      <List>
        <ListItem>
          <IconAlign>
            <AccountCircleIcon color={'te'} className={classes.icon} />
          </IconAlign>
          <ListItemText
            loading={loading}
            refresh={refetch}
            primary="Nome"
            secondary={((dataUser || {}).usuario || {}).nome + ' ' + ((dataUser || {}).usuario || {}).sobrenome}
          />
        </ListItem>
        <ListItem>
          <IconAlign>
            <AccessibilityIcon color={'te'} className={classes.icon} />
          </IconAlign>
          <ListItemText
            loading={loading}
            refresh={refetch}
            primary="Apelido"
            secondary={((dataUser || {}).usuario || {}).apelido}
          />
        </ListItem>
        <ListItem>
          <IconAlign>
            <MailSharpIcon color={'te'} className={classes.icon} />
          </IconAlign>
          <ListItemText loading={loading} refresh={refetch} primary="Email" secondary={((dataUser || {}).usuario || {}).email} />
        </ListItem>
        <Divider className={classes.hr} />
        <ListItem>
          <ChangePassword />
        </ListItem>
      </List>
    </Paper>
  )
}
export default ProfileInfo